/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Meta_TitleInputs */

const cs_settings_meta_title = /** @type {(inputs: Settings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta (Facebook / Instagram)`)
};

const en_settings_meta_title = /** @type {(inputs: Settings_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta (Facebook / Instagram)`)
};

/**
* | output |
* | --- |
* | "Meta (Facebook / Instagram)" |
*
* @param {Settings_Meta_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_meta_title = /** @type {((inputs?: Settings_Meta_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Meta_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_meta_title(inputs)
	return cs_settings_meta_title(inputs)
});